.se-container-wide {
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 15px;
  padding-right: 15px;
}

@media screen and (min-width: 980px) {
  .se-container-wide {
    padding-left: 10px;
    padding-right: 10px;
  }
}

@media screen and (max-width: 979px) {
  :host {
    width: 100%;
  }
}

.envsection__characteristics-wrapper {
  align-items: center;
}

@media screen and (max-width: 979px) {
  .envsection__characteristics-wrapper {
    display: flex;
    flex-direction: column;
  }
}

.envsection__characteristics-wrapper_expanded .envsection__characteristics {
  height: auto;
}

.envsection__characteristics {
  box-sizing: border-box;
}

.envsection__characteristics *,
.envsection__characteristics *::before,
.envsection__characteristics *::after {
  box-sizing: inherit;
}

@media screen and (min-width: 980px) {
  .envsection__characteristics {
    width: 776px;
    height: auto;
  }

  :host(:not([dir="rtl"])) .envsection__characteristics {
    margin-right: 32px;
  }

  :host([dir="rtl"]) .envsection__characteristics {
    margin-left: 32px;
  }
}

@media screen and (max-width: 979px) {
  .envsection__characteristics {
    height: 548px;
    overflow: hidden;
    width: 100%;
  }
}

.envsection_cell {
  padding: 12px 16px;
  display: flex;
  font-family: "ArialRoundedMTforSE", sans-serif;
  width: 50%;
  font-size: 14px;
  min-height: 48px;
  line-height: 20px;
  overflow-wrap: break-word;
}

.envsection__table {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.envsection__table > div:first-child div {
  margin-top: 0px;
}

.envsection_row {
  display: flex;
  width: 100%;
}

.envsection_cell.envsection_groupname {
  width: 100%;
  font-weight: bold;
  font-size: 15px;
  color: #007626;
  border-bottom: 2px solid #007626;
  margin-top: 40px;
}

@media screen and (max-width: 979px) {
  .envsection_cell.envsection_groupname {
    margin-top: 16px;
  }
}

.envsection_cell.envsection_groupname {
  width: 100%;
}

.envsection_cell.envsection_subgroup-name {
  display: flex;
  width: 100%;
  background-color: rgba(61, 205, 88, 0.1);
  font-weight: bold;
  align-items: center;
  color: #333333;
}

.envsection_characteristic-row {
  border-bottom: 1px solid #e6e6e6;
}

@media screen and (min-width: 980px) {
  :host(:not([dir="rtl"])) .envsection_characteristic-row {
    padding-left: 15px;
  }

  :host([dir="rtl"]) .envsection_characteristic-row {
    padding-right: 15px;
  }
}

.qds-icon__wrapper.envsection_subgroup-name-icon {
  font-size: 5px;
  width: 15px;
  height: 15px;
  color: #007626;
  font-weight: bold;
}

:host(:not([dir="rtl"])) .qds-icon__wrapper.envsection_subgroup-name-icon {
  margin-right: 10px;
}

:host([dir="rtl"]) .qds-icon__wrapper.envsection_subgroup-name-icon {
  margin-left: 10px;
}

:host(:not([dir="rtl"])) .env-characteristic .environment__tooltip-trigger {
  margin-left: 5px;
}

:host([dir="rtl"]) .env-characteristic .environment__tooltip-trigger {
  margin-right: 5px;
}

.envsection_cell-imgLogo {
  height: 32px;
  width: 32px;
  object-fit: contain;
}

:host(:not([dir="rtl"])) .envsection_cell-imgLogo {
  margin-right: 8px;
}

:host([dir="rtl"]) .envsection_cell-imgLogo {
  margin-left: 8px;
}

.envsection_cell-link-block {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
}

.envsection_cell-link {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

@media screen and (max-width: 979px) {
  .envsection_cell-link {
    white-space: normal;
  }
}

.envsection_cell-label-tooltip {
  display: flex;
  align-items: center;
  gap: 2px;
}

.envsection_cell-text-after {
  font-weight: normal;
}

.envsection_cell.env-value {
  display: flex;
  flex-direction: column;
  font-weight: bold;
  color: #626469;
  justify-content: center;
}

.envsection-cell-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  overflow-wrap: anywhere;
  color: #626469;
}

.envsection__view-more {
  margin-top: 16px;
}